angular.module('impactx.catalog').controller('ExternalCatalogCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    '$mdToast',
    'ConfirmationService',
    '$config',
    'ToolbarService',
    '$mdDialog',
    '$redirect',
    'TranslationService',
    'ToastService',
    '$location',
    '$rootScope',
    'DownloadService',
    'ExternalCatalogImportService',
    ExternalCatalogCtrl]);

function ExternalCatalogCtrl($scope, dataGen, $routeParams, BackService, $mdToast, ConfirmationService, $config, ToolbarService, $mdDialog,
                             $redirect, TranslationService, ToastService, $location, $rootScope, DownloadService, ExternalCatalogImportService) {
    var ctrl = this;
    $scope.tinymceOptions = $config.tinymceOptions;
    $scope.importFile = {};
    ctrl.errorList = [];

    var currentLocation = $location.path();
    var backButtonUsed = $rootScope.location !== currentLocation;
    if (backButtonUsed && $rootScope.previousRoute && $rootScope.previousRoute.originalPath.indexOf("internalcatalog") > -1 &&
        $rootScope.previousRoute.params && $rootScope.previousRoute.params.id && $rootScope.previousRoute.params.id === $routeParams.id) {
        BackService.back();
        return;
    }
    dataGen.getData($scope, {id: $routeParams.id}, "/catalog/viewexternal").then(function () {
        defineButtons();
        $scope.initiated = true;
    });

    this.save = function () {
        var dataObj = {
            cat: $scope.data
        };
        return dataGen.postAsForm($scope, dataObj, "/catalog/saveexternal").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    this.delete = function () {
        var dataObj = {
            catId: $scope.data.id
        };
        dataGen.postAsForm($scope, dataObj, "/catalog/delete").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.deleteSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    this.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(ctrl.delete, event, $scope.trns.confirmDelete,
            $scope.trns.delete, $scope.trns.abort);
    };

    this.addCatalogInterfaceField = function () {
        $scope.data.catalogInterfaceFields.push({});
    };

    this.removeCatalogInterfaceField = function (index) {
        $scope.data.catalogInterfaceFields.splice(index, 1);
    };

    this.addStandardField = function () {
        $scope.data.ociSettings.standardExtraFields.push({});
    };

    this.removeStandardField = function (index) {
        $scope.data.ociSettings.standardExtraFields.splice(index, 1);
    };

    this.openCatalogContractRelationDialog = function (event) {
        var catalogContractDialogSetting = {
            controller: 'CatalogContractDialogController',
            controllerAs: 'catalogContractDialogController',
            templateUrl: 'modules/catalog/templates/catalog-contract-dialog.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            bindToController: true,
            locals: {
                catId: $scope.data.id
            }
        };
        $mdDialog.show(catalogContractDialogSetting);
    };

    ctrl.convertToInternalCatalog = function () {
        var dataObj = {
            cat: $scope.data
        };
        return dataGen.postAsForm({}, {catId: $scope.data.id}, "/catalog/changeinternalexternal").then(function () {
            $redirect.redirectTo(null, "internalcatalog/" + $scope.data.id);
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        });
    };

    ctrl.canConvertToInternalCatalog = function () {
        return $scope.data.allowExternalCatalogConversion && !$scope.data.isInCheckoutOrRelease && !$scope.data.isSupplier;
    };

    function hasErrors() {
        return ctrl.errorList.length || missingCatalogManagers();
    }

    function missingCatalogManagers() {
        if ($scope.data.requireCatalogManager) {
            return $scope.data.catalogManager.relation.assigned.length < 1 && $scope.data.catalogManagerGroup.relation.assigned.length < 1
        }
        return false;
    }

    function getErrors() {
        var errors = [].concat(ctrl.errorList);
        if (missingCatalogManagers()) {
            errors.push($scope.trns.missingCatalogmanager);
        }
        return errors;
    }

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.save,
                type: 'validation',
                params: {
                    form: $scope.dialogData,
                    disableExpressions: {valueFunction: hasErrors, errorsFunction: getErrors}
                }
            },
            {
                label: $scope.trns.delete,
                action: ctrl.deleteDialog,
                type: 'dialogaction',
                condition: canDelete
            },
            {
                label: $scope.trns.convertToInternalCatalog,
                action: ctrl.convertToInternalCatalog,
                condition: ctrl.canConvertToInternalCatalog,
                process: 'Catalog'
            },
            {
                label: $scope.trns.importFiles,
                action: ctrl.importOciConfiguration,
                process: 'Catalog'
            },
            {
                label: $scope.trns.exportFiles,
                action: ctrl.exportOciConfiguration,
                process: 'Catalog'
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    this.importOciConfiguration = function (event) {
        ExternalCatalogImportService.showUploadDialog(event, $scope.trns, '/catalog/oci/import', parseInt($routeParams.id), writeOciConfiguration);
    };

    function writeOciConfiguration(response) {
        if (response.data.ociSettings && response.data.catalogInterfaceFields) {
            $scope.data.ociSettings = response.data.ociSettings;
            $scope.data.catalogInterfaceFields = response.data.catalogInterfaceFields;
        }
    }

    this.exportOciConfiguration = function () {
        DownloadService.openParamDownloadPost('/catalog/oci/export', [{paramName: "id", paramValue: parseInt($routeParams.id)}]);
    };

    function canDelete() {
        return !$scope.data.isInCheckoutOrRelease && $scope.data.id > 0;
    }

}
